// This is being used as both a type and a constant enum.. Open to where this should live..
export enum UserRole {
  VIEWER = 'viewer',
  MEMBER = 'member',
  ADMIN = 'admin',
  STAFF = 'staff',
  PUBLIC = 'public',
}

export interface UserProfile {
  user_roles: UserRole[]
  user_uuid: string
  client_name: string
  accepted_tsncs: boolean
  email: string
  date_created: Date | string | null
  status: string
  last_logged_in: string
  logged_in_count: string
  show_changelog: boolean
}

export interface UserHeadCell {
  id: keyof UserHeadCellData
  label: string
  numeric: boolean
  sortable: boolean
  align?: 'left' | 'right' | 'center'
}

export interface UserHeadCellData {
  id: string
  email: string
  date_created: string
  logged_in_count: number
  status: string
  user_roles: UserRole[]
  last_logged_in: string
  delete_user: null
  edit_user: null
  resend_invite: null
}

export type SortableUserHeadCell = Omit<
  UserHeadCellData,
  'id' | 'delete_user' | 'edit_user' | 'resend_invite'
>

export interface UserCustomRole {
  id: number
  name: string
  description: string
  client_name: string
}

export type UserCustomRoleResponse = UserCustomRole[]
